import {
  UserLanguage,
  resolveUserLanguageWDefault,
} from "@aistihealth/web-common/src/typings/userLanguage"
import { Language as GqlLanguage } from "./generated/graphql"

const i18nLanguagesToGqlApiLanguage: Record<UserLanguage, GqlLanguage> = {
  en: GqlLanguage.En,
  fi: GqlLanguage.Fi,
  sv: GqlLanguage.Sv,
}

export const i18nLanguageToGqlApiLanguage = (language: string): GqlLanguage => {
  const userLang = resolveUserLanguageWDefault(language)
  return i18nLanguagesToGqlApiLanguage[userLang]
}
